import { jsx as _jsx } from "react/jsx-runtime";
import Big from 'big.js';
import { FormattedMessage } from 'react-intl';
const validate = ({ value, decimals, minimum, maximum, canBeZero }) => {
    const res = {
        number: false,
        decimals: false,
        minimum: false,
        maximum: false,
        zero: false,
    };
    if (!value) {
        return { ...res, isValid: false };
    }
    try {
        const amount = Big(value);
        res.number = true;
        res.minimum = !!minimum ? amount.gte(minimum) : true;
        res.maximum = !!maximum ? amount.lte(maximum) : true;
        res.zero = !canBeZero ? amount.gt(0) : true;
        const decimalIndex = value.indexOf('.');
        const decimal = decimalIndex !== -1 ? value.substring(decimalIndex + 1) : undefined;
        res.decimals = !!decimals ? (!!decimal ? decimal.length <= decimals : true) : true;
    }
    catch {
    }
    finally {
        return {
            ...res,
            isValid: Object.values(res).every((it) => !!it),
        };
    }
};
export const useValidateTokenAmount = () => {
    return (params) => {
        const state = validate(params);
        const errors = [];
        if (!state.number) {
            errors.push(_jsx(FormattedMessage, { id: "validate-token-amount.generic" }));
        }
        if (!state.decimals) {
            errors.push(_jsx(FormattedMessage, { id: "validate-token-amount.decimals", values: { number: params.decimals } }));
        }
        if (!state.zero) {
            errors.push(_jsx(FormattedMessage, { id: "validate-token-amount.zero" }));
        }
        if (!state.minimum) {
            errors.push(_jsx(FormattedMessage, { id: "validate-token-amount.minimum", values: { number: params.minimum } }));
        }
        if (!state.maximum) {
            errors.push(_jsx(FormattedMessage, { id: "validate-token-amount.maximum", values: { token: params.token.symbol } }));
        }
        return { isValid: state.isValid, errors, state };
    };
};
